import React, { useState } from 'react';
import { auth } from '../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import Layout from '../components/Layout';

export default function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, 'roland@a-ldi.com', password);
    } catch {
      setError('Incorrect password. Please try again.');
    }
    setLoading(false);
  }

  return (
    <Layout pageTitle="Service Calendar" pageSubtitle="Grand Hyatt San Antonio — Preventative Maintenance">
      <div style={{ maxWidth: 380, margin: '48px auto' }}>
        <div className="card">
          <div style={{ textAlign: 'center', marginBottom: 24, paddingBottom: 16, borderBottom: '2px solid var(--red)' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>🔐</div>
            <div style={{ fontFamily: 'Oswald, sans-serif', fontSize: 17, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--navy)' }}>A-LDI Admin Login</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>Roland Rodriguez — American Laundry Distributors</div>
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" autoFocus required />
            </div>
            <button type="submit" className="btn btn-primary w-full" style={{ width: '100%', justifyContent: 'center', padding: '11px', marginTop: 6 }} disabled={loading}>
              {loading ? 'Signing In…' : 'Sign In'}
            </button>
          </form>
          <p style={{ marginTop: 16, fontSize: 11, color: 'var(--text-muted)', textAlign: 'center' }}>
            Grand Hyatt staff: use your private view link.<br />
            Contact <a href="mailto:info@a-ldi.com" style={{ color: 'var(--navy)' }}>info@a-ldi.com</a> for access.
          </p>
        </div>
      </div>
    </Layout>
  );
}
